module.exports = __webpack_public_path__ + "fonts/DM_Serif_Display-400-latin-ext2.2f3c97e.woff2";